module.exports = __webpack_public_path__ + "img/startmarker-min.7283e489.png";